import React, { ChangeEvent, useRef } from 'react'
import './inputfield.scss'
import useInputValidation from '../../hooks/useInputValidation'
import { InputFieldPropsInterface } from '../../utils/constants/Interfaces.constants'
import infoIcon from "../../assets/info-circle-icon.png";


const InputField: React.FunctionComponent<InputFieldPropsInterface> = ({
    labelFor = "",
    label = '',
    id,
    type = 'text',
    value,
    onChangeInput,
    name,
    required = false,
    maxLength,
    minLength = 0,
    pattern,
    className = "",
    placeholder,
    disabled = false,
    onInput = () => { },
    numberOnly = false,
    showErrors = true,
    toolTip = false,
    
  
    tooltipText = '',
    onKeyDown,
    
    
}) => {
    const { bindValue, error } = useInputValidation()
        // Create a ref for the input field
    const inputRef = useRef<HTMLInputElement>(null);

    const validateInputType = (ev: any) => {
        if (isNaN(parseInt(ev.target.value))) {
            ev.target.value = ""
        }
    }

    const handleOnInput = (ev: any) => {
        if (numberOnly) validateInputType(ev)
        if (typeof onInput === 'function') onInput(ev)
            
    }
    
    const handleIconClick = () => {
        // console.log('Called')
        if (inputRef.current && type === 'date') {
                //  console.log('inside cond')
            inputRef.current.focus();
        }
    }


    return (
        <div className="mf-admin-inputfield-container input-container d-flex flex-column">
            <input
                data-border={!showErrors}
                className={'mf-admin-inputfield ' + className}
                name={name}
                id={id}
                type={type}
                value={value}
                onChange={onChangeInput}
                required={required}
                minLength={minLength}
                maxLength={maxLength}
                pattern={pattern}
                placeholder={placeholder}
                disabled={disabled}
                onInput={handleOnInput}
                onKeyDown={onKeyDown}
                onClick={handleIconClick}
                 ref={inputRef}  
                {...bindValue(name)}
            />
            {toolTip && (<div className="tooltip-container" >  <img src={infoIcon} width='14' height='14' alt='info' />
                <span className="tooltip-text">{tooltipText}</span>
            </div>)}

            {
                label?.length !== 0 &&
                <label className='text-primary-color weight-500 text-capitalize mf-admin-inputfield-label mb-1' htmlFor={labelFor}>{label}</label>
            }

           { error && <p className="mb-0 error-msg weight-500">{error}</p>}

        </div>
    )
}

export default InputField